import { createFileRoute, redirect } from '@tanstack/react-router';

// Chain search detail moved under /dashboard/chains/searches/$uuid when the
// standalone Chain searches nav/table was removed. Keep old links working.
export const Route = createFileRoute('/dashboard/scorecard/chains_/$uuid')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/dashboard/chains/searches/$uuid',
      params: { uuid: params.uuid },
    });
  },
});
